export const ACCOUNT_LABELS = 'account';
export const GLOBAL_LABELS = 'global';
export const CHECKOUT_LABELS = 'checkout';

// account paymentGC
export const lblPaymentExpDate = 'lbl_payment_expDate';
export const lblPaymentCardNum = 'lbl_payment_cardNum';
export const lblPaymentCheckBalance = 'lbl_payment_checkBalance';
export const lblPaymentRemainingBalance = 'lbl_payment_remainingBalance';
export const lblPaymentDefaultPayment = 'lbl_payment_defaultPayment';
export const lblPaymentGiftCard = 'lbl_payment_giftCard';
export const lblPaymentVenmoAccount = 'lbl_payment_venmoAccount';
export const lblPaymentApplepayAccount = 'lbl_payment_applepayAccount';
export const lblPaymentCCEmptyHeading = 'lbl_payment_CCEmptyHeading';
export const lblPaymentGCEmptyHeading = 'lbl_payment_GCEmptyHeading';
export const lblPaymentCCEmptyDesc = 'lbl_payment_CCEmptyDesc';
export const lblPaymentGCEmptyDesc = 'lbl_payment_GCEmptyDesc';

// account common
export const lblCommonDelete = 'lbl_common_delete';
export const lblCommonMakeDefault = 'lbl_common_makeDefault';
export const lblGiftCardBalanceLoading = 'lbl_giftCardBalanceLoading';
export const lblCommonCouponTypePlacecash = 'lbl_common_couponTypePlacecash';
export const lblCommonCouponTypeReward = 'lbl_common_couponTypeReward';
export const lblCommonCouponTypeSaving = 'lbl_common_couponTypeSaving';
export const lblBiaMainTitle = 'lbl_bia_main_title';
export const lblRnrMainTitle = 'lbl_rnr_main_title';
export const lblCommonEarnExtraPoints = 'lbl_common_earnExtraPoints';
export const lblEarnExtraPointsGetReward = 'lbl_earnExtraPoints_getReward';
export const lblCommonViewAll = 'lbl_common_viewAll';
export const lblExtraExtraPointsMorePoints = 'lbl_extraExtraPoints_more_points';
export const lblCommonExtraPointsHeading = 'lbl_common_extraPointsHeading';
export const lblCommonExtraPointsSubHeading = 'lbl_common_extraPoints_sub_heading';
export const lblCommonEarnExtraPointsPageHeading = 'lbl_common_earn_extra_points_page_heading';
export const lblCommonTermsAndCondition = 'lbl_common_terms_and_condition';
export const lblCommonLearnMore = 'lbl_common_learn_more';
export const lblCommonOrderDate = 'lbl_common_order_date';
export const lblCommonDescription = 'lbl_common_description';
export const lblCommonDate = 'lbl_common_date';
export const lblCommonPointBalance = 'lbl_common_point_balance';
export const lblCommonCurrentPoints = 'lbl_common_current_points';
export const lblCommonPoints = 'lbl_common_points';
export const lblCommonBalance = 'lbl_common_balance';
export const lblCommonPointsTransaction = 'lbl_common_points_transaction';
export const lblCommonSeeMore = 'lbl_common_see_more';
export const lblCommonViewFullPointHistory = 'lbl_common_view_full_point_history';
export const lblCommonTransaction = 'lbl_common_transaction';
export const lblCommonPointsEarned = 'lbl_common_points_earned';
export const lblCommonPointsHistory = 'lbl_common_points_history';
export const lblCommonPointsHistoryHeading = 'lbl_common_points_history_heading';
export const lblCommonPointsHistoryNopoints = 'lbl_common_points_history_nopoints';
export const lblCommonFor = 'lbl_common_for';
export const lblCommonReward = 'lbl_common_reward';
export const lblCommonEngagementBonus = 'lbl_common_engagement_bonus';
export const lblCommonPurchase = 'lbl_common_purchase';
// account accountOverview
export const lblOverviewCouponValid = 'lbl_overview_couponValid';
export const lblOverviewCouponUseBy = 'lbl_overview_couponUseBy';
export const lblOverviewProfileInfoMailingAddress = 'lbl_overview_profileInfoMailingAddress';
export const lblOverviewProfileInfoChangeCTA = 'lbl_overview_profileInfoChangeCTA';
export const lblOverviewProfileInfoMember = 'lbl_overview_profileInfoMember';
export const lblOverviewProfileInfoViewCTA = 'lbl_overview_profileInfoViewCTA';
export const lblOverviewEarnPointsHeading = 'lbl_overview_earnPointsHeading';
export const lblOverviewProfileInformationHeading = 'lbl_overview_profileInformationHeading';
export const lblOverviewAddressBookHeading = 'lbl_overview_addressBookHeading';
export const lblOverviewMyPreferencesHeading = 'lbl_overview_myPreferencesHeading';
export const lblOverviewChatNow = 'lbl_overview_chat_now';
export const lblHeaderStoreDefaultTitle = 'lbl_header_storeDefaultTitle';
export const lblOverviewTrackYourOrder = 'lbl_overview_trackYourOrder';
export const lblOverviewHeaderMyFavorite = 'lbl_overview_headerMyFavorite';
export const lblOverviewOrdersHeading = 'lbl_overview_ordersHeading';
export const lblOverviewQuickLinks = 'lbl_overview_quickLinks';
export const lblOverviewMyWalletHeading = 'lbl_overview_myWalletHeading';
export const lblOverviewMyStore = 'lbl_overview_myStore';
export const lblOverviewMyFavoritesHeading = 'lbl_overview_myFavoritesHeading';
export const lblOverviewMemberId = 'lbl_overview_memberId';
export const lblOverviewCreditCard = 'lbl_overview_creditCard';
export const lblOverviewMemberIdHeading = 'lbl_overview_memberIdHeading';
export const lblOverviewShowMemberID = 'lbl_overview_showMemberID';
export const lblOverviewMyDashboard = 'lbl_overview_myDashboard';
export const lblPlaceperkMystatusHeader = 'lbl_placeperk_mystatus_header';
export const lblPlaceperkToUnlock = 'lbl_placeperk_to_unlock';
export const lblOverviewToReach = 'lbl_overview_to_reach';
export const lblRewardPointsEarningAwayText = 'lbl_rewardPoints_earningAwayText';
export const lblRewardPointsRewardsAvailable = 'lbl_rewardPoints_rewardsAvailable';
export const lblOverviewViewDashboard = 'lbl_overview_viewDashboard';
export const lblPlaceperkCongratsShort = 'lbl_placeperk_congrats_short';
export const lblOverviewSpend = 'lbl_overview_spend';
export const lblOverviewUntillYourNext = 'lbl_overview_untill_your_next';
export const lblOverviewPerkDashboard = 'lbl_overview_perkDashboard';
export const lblOverviewRewardDashboard = 'lbl_overview_rewardDashboard';
export const lblOverviewCheckBalance = 'lbl_overview_check_balance';
export const lblOverviewMyPlaceRewardsText = 'lbl_overview_myPlaceRewardsText';
export const lblOverviewTodayText = 'lbl_overview_todayText';
export const lblOverviewWhenToOpenAndUseText = 'lbl_overview_whenToOpenAndUseText';
export const lblOverviewOnYourFirstPurchaseText = 'lbl_overview_onYourFirstPurchaseText';
export const lblOverviewManageMyCardText = 'lbl_overview_manageMyCardText';
export const lblOverviewApplyNowText = 'lbl_overview_applyNowText';
export const lblOverviewGreeting = 'lbl_overview_greeting';
export const lblOverviewShowAccountNumber = 'lbl_overview_show_account_number';
export const lblOverviewHideAccountNumber = 'lbl_overview_hide_account_number';
export const lblOverviewAddToAppleWallet = 'lbl_overview_add_to_apple_wallet';
export const lblOverviewAddToGooglePay = 'lbl_overview_add_to_google_pay';
export const lblOverviewAddressNotAdded = 'lbl_overview_addressNotAdded';
export const lblOverviewAddressBookCTA = 'lbl_overview_addressBookCTA';
export const lblOverviewDefaultShipingAddress = 'lbl_overview_defaultShipingAddress';
export const lblOverviewAddressBookAdd = 'lbl_overview_addressBookAdd';
export const lblOverviewDefaultBillingAddress = 'lbl_overview_defaultBillingAddress';
export const lblPlaceperkMyPerk = 'lbl_placeperk_my_perk';
export const lblBonusPointsHeading = 'lbl_bonus_points_heading';
export const lblOverviewManageYourCard = 'lbl_overview_manageYourCard';
export const lblOverviewApplyOrAcceptOffer = 'lbl_overview_applyOrAcceptOffer';
export const lblOverviewCardEnding = 'lbl_overview_card_ending';
export const lblOverviewYourKidsBirthdays = 'lbl_overview_yourKidsBirthdays';
export const lblOverviewWhenYouCheckout = 'lbl_overview_whenYouCheckout';
export const lblOverviewAddYourCardTo = 'lbl_overview_addYourCardTo';
export const lblOverviewAddYourCard = 'lbl_overview_addYourCard';
export const lblOverviewDontHaveMyPlaceCard = 'lbl_overview_dontHaveMyPlaceCard';
export const lblOverviewMyPlaceRewardsDesc = 'lbl_overview_myPlaceRewardsDesc';
export const lblOverviewMyPlaceRewardsCTA = 'lbl_overview_myPlaceRewardsCTA';
export const lblOverviewMyPlaceRewardsAvailable = 'lbl_overview_myPlaceRewardsAvailable';
export const lblOverviewMyWalletOfferAvailable = 'lbl_overview_myWalletOfferAvailable';
export const lblOverviewWalletViewAllCTA = 'lbl_overview_walletViewAllCTA';
export const lblOverviewMyWalletNoOfferAvailable = 'lbl_overview_myWalletNoOfferAvailable';
export const lblOverviewViewMyWalletCTA = 'lbl_overview_viewMyWalletCTA';
export const lblOverviewMyWalletStartShop = 'lbl_overview_myWalletStartShop';
export const lblOverviewRemainingBalance = 'lbl_overview_remaining_balance';
export const lblOverviewVenmo = 'lbl_overview_venmo';
export const lblOverviewExpires = 'lbl_overview_expires';
export const lblOverviewDefaultCreditCard = 'lbl_overview_default_creditCard';
export const lblOverviewAddCreditCard = 'lbl_overview_add_creditCard';
export const lblOverviewViewPayments = 'lbl_overview_view_payments';
export const lblOverviewPaymentHeading = 'lbl_overview_paymentHeading';
export const lblOverviewGiftCard = 'lbl_overview_giftCard';
export const lblOverviewAddGiftCard = 'lbl_overview_add_giftCard';
export const lblPlaceperkNoPerk = 'lbl_placeperk_no_perk';
export const lblPlaceperkHeader = 'lbl_placeperk_header';
export const lblPlaceperkViewDashboard = 'lbl_placeperk_view_dashboard';

// account profile
export const lblProfileAddChildBirthdayCta = 'lbl_profile_addChildBirthdayCta';
export const lblProfileBirthdaySavingInfo = 'lbl_profile_birthday_saving_info';
export const lblProfileRemoveInfoText = 'lbl_profile_removeInfoText';
export const lblProfileRemoveCTA = 'lbl_profile_removeCTA';
export const lblProfileRemoveCancelCTA = 'lbl_profile_removeCancelCTA';
export const lblProfileRemoveBirthdaySuccess = 'lbl_profile_removeBirthdaySuccess';
export const lblProfileGenericError = 'lbl_profile_genericError';
export const lblProfileDEFAULTERROR = 'lbl_profile_DEFAULT_ERROR';
export const lblProfileERRDBPOPULATE = 'lbl_profile_ERR_DBPOPULATE';
export const lblProfileERRINVALIDCOOKIE = 'lbl_profile__ERR_INVALID_COOKIE';
export const lblProfileASSOCIATEIDNOTVALID = 'lbl_profile_ASSOCIATE_ID_NOT_VALID';
export const lblProfileTCPEMAILADDRESSALREADYEXIST = 'lbl_profile__TCP_EMAIL_ADDRESS_ALREADY_EXIST';
export const lblProfileANERROROCCURREDPLEASETRYAGAIN =
  'lbl_profile_AN_ERROR_OCCURRED_PLEASE_TRY_AGAIN';
export const lblProfilePLEASEENTERAVALIDEXPIRATIONDATE =
  'lbl_profile_PLEASE_ENTER_A_VALID_EXPIRATION_DATE';
export const lblProfileTRYLOGGINGOUTANDLOGBACKINORTRYAGAINLATER =
  'lbl_profile_TRY_LOGGING_OUT_AND_LOG_BACK_IN_OR_TRY_AGAIN_LATER';

// account preferences
export const lblPrefrenceHeading = 'lbl_prefrence_heading';
export const lblPrefrenceViewPreferences = 'lbl_prefrence_view_preferences';
export const lblPreferenceTileAdd = 'lbl_preference_tileAdd';
export const lblPreferenceTileContactPreference = 'lbl_preference_tileContactPreference';
export const lblPreferenceTileTextText = 'lbl_preference_tileTextText';
export const lblPreferenceTileAppText = 'lbl_preference_tileAppText';
export const lblPrefrenceTileFavoriteStore = 'lbl_prefrence_tileFavoriteStore';
export const lblPreferenceTileAccessBuyOnlinePickup = 'lbl_preference_tileAccessBuyOnlinePickup';
export const lblPreferenceTileConnectedSocialAccountsHeading =
  'lbl_preference_tileConnectedSocialAccountsHeading';
export const lblPreferenceTileConnectedSocialAccountsText =
  'lbl_preference_tileConnectedSocialAccountsText';

// checkout bagPage
export const lblCouponlistAvailable = 'lbl_couponlist_available';
export const lblCouponCollapsibleHeader = 'lbl_coupon_collapsible_header';
export const lblCouponlistApplied = 'lbl_couponlist_applied';
export const lblCouponlistRewards = 'lbl_couponlist_rewards';

// global registration
export const lblCreateAccountUseTouchId = 'lbl_createAccount_useTouchId';
export const lblCreateAccountUseFaceId = 'lbl_createAccount_useFaceId';

// global header
export const lblHeaderHelloText = 'lbl_header_helloText';

// global accountDrawer
export const lblStartEarningPointsLabel = 'lbl_startEarningPoints_label';
export const lblAccoundDashboardNoRewardsOffers = 'lbl_accoundDashboard_noRewardsOffers';
export const lblRewardsAndOffersRecentRewards = 'lbl_rewardsAndOffers_recent_rewards';
export const lblRewardsAndOffersStartShopping = 'lbl_rewardsAndOffers_start_shopping';
export const lblAccountDrawerRememberUser = 'lbl_accountDrawer_rememberUser';
export const lblAccoundDashboardPaymentGiftCards = 'lbl_accoundDashboard_paymentGiftCards';
export const lblPaymentOverviewTileAddCard = 'lbl_paymentOverviewTile_addCard';
export const lblPaymentOverviewTileAddCreditOrGift = 'lbl_paymentOverviewTile_addCreditOrGift';
export const lblPaymentOverviewTileAddGiftCard = 'lbl_paymentOverviewTile_addGiftCard';
export const lblPaymentOverviewTileCardNumber = 'lbl_paymentOverviewTile_cardNumber';
export const lblPaymentOverviewTileAddCreditCard = 'lbl_paymentOverviewTile_addCreditCard';
export const lblRewardPointStatusBarViewMyRewards = 'lbl_rewardPointStatusBar_viewMyRewards';
export const lblRewardPointStatusBarToNextAward = 'lbl_rewardPointStatusBar_toNextAward';

// global cartItemTile
export const lblViewAll = 'lbl_view_all';

// global placeRewards
export const lblMyRewardsEmptySupportingText = 'lbl_my_rewards_emptySupportingText';
export const lblMyCouponTitle = 'lbl_my_coupon_title';
export const lblMyRewardsViewAll = 'lbl_my_rewards_viewAll';
export const lblMyRewardsEmptySupportingTextUS = 'lbl_my_rewards_emptySupportingText_US';

// global recommendations
export const CTA_TEXT = 'CTA_TEXT';

// global myPlaceRewards
export const lblShowMemberId = 'lbl_showMemberId';
export const lblPlaceRewardsBoostYourPoints = 'lbl_place_reward_boost_your_points';
export const lblPlaceRewardsBoostYourPointsSubHeading =
  'lbl_place_reward_boost_your_points_sub_heading';
export const lblPlaceRewardsAdd = 'lbl_place_reward_add';
export const lblPlaceRewardsPointHistoryHeading = 'lbl_place_reward_point_history';
export const lblPlaceRewardsPointHistorySubHeading = 'lbl_place_reward_point_history_sub_heading';
export const lblPlaceRewardsViewAllWaysToEarn = 'lbl_place_reward_view_all_ways_to_earn';

// global addEditAddress
export const lblAddEditAddressEmail = 'lbl_addEditAddress_email';

// global rewardPoints
export const lblRewardPointsCurrentPoints = 'lbl_rewardPoints_currentPoints';
export const lblRewardPointsHeading = 'lbl_rewardPoints_heading';
export const lblRewardPointsNextReward = 'lbl_rewardPoints_nextReward';

// global accountTier
export const lblAccountTierValidity = 'lbl_accountTier_validity';
export const lblAccountPlccHolder = 'lbl_accountTier_plccHolder';
export const lblAccountTierUpgradeTo = 'lbl_accountTier_upgradeTo';
export const lblAccountTierNextRewardTarget = 'lbl_accountTier_nextRewardTarget';
export const lblAccountTierWelMyPlaceHeading = 'lbl_accountTier_welMyPlaceHeading';
export const lblAccountTierWelMyPlaceSubHeading = 'lbl_accountTier_welMyPlaceSubHeading';
export const lblAccountTierAvailableReward = 'lbl_accountTier_AvailableReward';
export const lblAccountTierRedeemAt = 'lbl_accountTier_RedeemAt';
export const lblAccountTierYourSpend = 'lbl_accountTier_YourSpend';
export const lblAccountTierUpgradeDescription = 'lbl_accountTier_UpgradeDescription';
export const lblAccountTierMaxTier = 'lbl_accountTier_MaxTier';
export const lblAccountTierMaxTierInfo = 'lbl_accountTier_MaxTierInfo';
export const lblAccountTierReached = 'lbl_accountTier_Reached';
export const lblAccountTierMaxTierMyPlace = 'lbl_accountTier_MaxTierMyPlace';
export const lblTierBenefitsHeading = 'lbl_tierBenefits_Heading';
export const lblTierBenefitsSubHeading = 'lbl_tierBenefits_subHeading';
export const lblTierBenefitsExpiringSoon = 'lbl_tierBenefits_expiringSoon';
export const lblTierBenefitsRemaining = 'lbl_tierBenefits_remaining';
export const lblTierBenefitsUsed = 'lbl_tierBenefits_used';
export const lblLoyaltyBenefitsHeading = 'lbl_loyalty_benefits_heading';
export const lblLoyaltyBenefitSubHeading = 'lbl_loyalty_benefit_subheading';
export const lblConsumeUpTo = 'lbl_consume_up_to';
export const lblRedeem = 'lbl_Redeem';
export const lblConsumed = 'lbl_consumed';
export const lblPointsRedemptionError = 'lbl_points_redemption_error';
export const lblCartAmountError = 'lbl_cart_amount_error';
export const lblBenefitComparisonHeading = 'lbl_benefit_comparison_heading';
export const lblBenefitComparisonSubHeading = 'lbl_benefit_comparison_sub_heading';
export const lblAllBenefitHeading = 'lbl_all_benefit_heading';

// global plcc
export const lblNonPlccUserHeading = 'lbl_non_plcc_user_heading';
export const lblNonPlccUserSubheading = 'lbl_non_plcc_sub_heading';
export const lblPlccUserHeading1 = 'lbl_plcc_user_heading1';
export const lblPlccUserHeading2 = 'lbl_plcc_user_heading2';
export const lblPlccUserSubheading = 'lbl_plcc_sub_heading';
export const lblPlccSavings = 'lbl_plcc_savings';

const AccountCommonLabels = {
  account: {
    paymentGC: {
      [lblPaymentExpDate]: 'Expires on ',
      [lblPaymentCardNum]: 'Card ending in ',
      [lblPaymentCheckBalance]: ' Check Balance',
      [lblPaymentRemainingBalance]: 'Remaining balance',
      [lblPaymentDefaultPayment]: 'Default',
      [lblPaymentGiftCard]: 'Gift Card',
      [lblPaymentVenmoAccount]: 'Your Venmo Account',
      [lblPaymentApplepayAccount]: 'Your Applepay Account',
      [lblPaymentCCEmptyHeading]: 'Add a credit or debit card to check out faster!',
      [lblPaymentGCEmptyHeading]: 'Have a gift card?',
      [lblPaymentCCEmptyDesc]:
        'Securely save your credit card, and/or My Place Rewards Card information so you can check out even faster!',
      [lblPaymentGCEmptyDesc]:
        'Save up to 5 gift cards and/or merchandise cards to use the next time you shop.',
    },
    common: {
      [lblCommonDelete]: 'Delete',
      [lblCommonMakeDefault]: 'Make Default',
      [lblGiftCardBalanceLoading]: 'LOADING...',
      [lblCommonCouponTypePlacecash]: 'PLACE BUCKS',
      [lblCommonCouponTypeReward]: 'REWARD',
      [lblCommonCouponTypeSaving]: 'SAVINGS',
      [lblBiaMainTitle]: 'Buy it Again',
      [lblRnrMainTitle]: 'Rate & Review',
      [lblCommonEarnExtraPoints]: 'Earn Extra Points',
      [lblEarnExtraPointsGetReward]: 'Get even closer to your next reward. ',
      [lblCommonViewAll]: 'View All',
      [lblExtraExtraPointsMorePoints]: 'Earn even more points by activating these offers!',
      [lblCommonExtraPointsHeading]: 'EARN EXTRA POINTS',
      [lblCommonOrderDate]: 'ORDER DATE',
      [lblCommonTransaction]: 'TRANSACTION',
      [lblCommonPointsEarned]: 'POINTS EARNED',
      [lblCommonPointsHistory]: 'Points History',
      [lblCommonPointsHistoryHeading]: 'POINTS HISTORY',
      [lblCommonPointsHistoryNopoints]:
        "Looks like you don't have any points yet... Shop now to start earning points (and get rewards)!",
      [lblCommonDescription]: 'Description',
      [lblCommonDate]: 'DATE',
      [lblCommonPointBalance]: 'Points Balance',
      [lblCommonCurrentPoints]: 'You currently have ##points## points.',
      [lblCommonPoints]: 'Points',
      [lblCommonBalance]: 'Balance',
      [lblCommonPointsTransaction]: 'Points Transaction',
      [lblCommonSeeMore]: 'See More',
      [lblCommonViewFullPointHistory]: 'View Full Points History',
      [lblCommonFor]: 'for',
      [lblCommonReward]: 'Reward',
      [lblCommonPurchase]: 'Purchase',
      [lblCommonEngagementBonus]: 'Engagement Bonus',
      [lblCommonLearnMore]: 'Learn More',
      [lblCommonExtraPointsSubHeading]:
        'Complete the following actions to earn points & rewards even faster.',
      [lblCommonEarnExtraPointsPageHeading]:
        'Extra points earned will be applied to your account within 24-48 hours.',
      [lblCommonTermsAndCondition]: 'Terms & Conditions',
    },
    accountOverview: {
      [lblOverviewCouponValid]: 'Valid',
      [lblOverviewCouponUseBy]: 'Use by',
      [lblOverviewProfileInfoMailingAddress]: 'Mailing Address',
      [lblOverviewProfileInfoChangeCTA]: 'Change',
      [lblOverviewProfileInfoMember]: 'Member #',
      [lblOverviewProfileInfoViewCTA]: 'VIEW PROFILE',
      [lblOverviewEarnPointsHeading]: 'Earn Extra Points',
      [lblOverviewProfileInformationHeading]: 'Profile Information',
      [lblOverviewAddressBookHeading]: 'Address Book',
      [lblOverviewMyPreferencesHeading]: 'Preferences',
      [lblOverviewChatNow]: 'CHAT NOW',
      [lblHeaderStoreDefaultTitle]: 'FIND A STORE',
      [lblOverviewTrackYourOrder]: 'Track Your Order',
      [lblOverviewHeaderMyFavorite]: 'My Favorite',
      [lblOverviewOrdersHeading]: 'Orders',
      [lblOverviewQuickLinks]: 'Quick Links',
      [lblOverviewMyWalletHeading]: 'Wallet',
      [lblOverviewMyStore]: 'My Store',
      [lblOverviewMyFavoritesHeading]: 'Favorites',
      [lblOverviewMemberId]: 'Member ID',
      [lblOverviewCreditCard]: 'Credit Card',
      [lblOverviewMemberIdHeading]: 'Member ID',
      [lblOverviewShowMemberID]: 'Show Member ID',
      [lblOverviewMyDashboard]: 'My Dashboard',
      [lblPlaceperkMystatusHeader]: 'MY STATUS',
      [lblPlaceperkToUnlock]: 'to unlock ',
      [lblOverviewToReach]: 'to reach',
      [lblRewardPointsEarningAwayText]: 'away from earning your next',
      [lblRewardPointsRewardsAvailable]: 'Rewards Available',
      [lblOverviewViewDashboard]: 'View Dashboard',
      [lblPlaceperkCongratsShort]: 'CONGRATS',
      [lblOverviewSpend]: 'Spend $',
      [lblOverviewUntillYourNext]: 'until your next',
      [lblOverviewPerkDashboard]: 'Perk Dashboard',
      [lblOverviewRewardDashboard]: 'Rewards Dashboard',
      [lblOverviewCheckBalance]: 'Check Balance',
      [lblOverviewMyPlaceRewardsText]: 'MY PLACE REWARDS',
      [lblOverviewTodayText]: 'TODAY!',
      [lblOverviewWhenToOpenAndUseText]: 'when you open & use the',
      [lblOverviewOnYourFirstPurchaseText]: 'on your first purchase',
      [lblOverviewManageMyCardText]: 'Manage My Card',
      [lblOverviewApplyNowText]: 'Apply Now',
      [lblOverviewGreeting]: 'Hi,',
      [lblOverviewShowAccountNumber]: 'Show My Account Number',
      [lblOverviewHideAccountNumber]: 'Hide My Account Number',
      [lblOverviewAddToAppleWallet]: 'ADD TO APPLE WALLET',
      [lblOverviewAddToGooglePay]: 'ADD TO GOOGLE PAY',
      [lblOverviewAddressNotAdded]: 'Add an address for faster checkout.',
      [lblOverviewAddressBookCTA]: 'VIEW ADDRESS BOOK',
      [lblOverviewDefaultShipingAddress]: 'Default Shipping Address',
      [lblOverviewAddressBookAdd]: 'Add',
      [lblOverviewDefaultBillingAddress]: 'Default Billing Address',
      [lblPlaceperkMyPerk]: 'My Recent Benefits',
      [lblBonusPointsHeading]: 'BONUS POINTS BENEFITS',
      [lblOverviewManageYourCard]: 'MANAGE YOUR CARD',
      [lblOverviewApplyOrAcceptOffer]: 'APPLY OR ACCEPT OFFER',
      [lblOverviewCardEnding]: 'ending in',
      [lblOverviewYourKidsBirthdays]: ' your kids’ birthdays!',
      [lblOverviewWhenYouCheckout]: ' when you check out using your card',
      [lblOverviewAddYourCardTo]: 'Add your card to:',
      [lblOverviewAddYourCard]: 'ADD YOUR CARD',
      [lblOverviewDontHaveMyPlaceCard]: 'Don’t have a My Place Rewards Credit Card?',
      [lblOverviewMyPlaceRewardsDesc]: 'Start Shopping to earn points!',
      [lblOverviewMyPlaceRewardsCTA]: 'VIEW ALL REWARDS',
      [lblOverviewMyPlaceRewardsAvailable]: 'You have {0} available rewards.',
      [lblOverviewMyWalletOfferAvailable]: 'You have {0} available rewards and offers.',
      [lblOverviewWalletViewAllCTA]: 'VIEW ALL',
      [lblOverviewMyWalletNoOfferAvailable]: 'There are no available rewards or offers.',
      [lblOverviewViewMyWalletCTA]: 'VIEW MY WALLET',
      [lblOverviewMyWalletStartShop]: 'Start shopping to earn points!',
      [lblOverviewRemainingBalance]: 'Remaining balance',
      [lblOverviewVenmo]: 'Venmo',
      [lblOverviewExpires]: 'expires',
      [lblOverviewDefaultCreditCard]: 'Default Credit Card',
      [lblOverviewAddCreditCard]: 'Add a credit card for faster checkout.',
      [lblOverviewViewPayments]: 'View Payment & Gift Cards',
      [lblOverviewPaymentHeading]: 'Payment & Gift Cards',
      [lblOverviewGiftCard]: 'Gift Card(s)',
      [lblOverviewAddGiftCard]: 'Add a gift card for faster checkout.',
      [lblPlaceperkNoPerk]: 'NO PERK',
      [lblPlaceperkHeader]: 'My Place Rewards Status',
      [lblPlaceperkViewDashboard]: 'My Status Dashboard',
    },
    profile: {
      [lblProfileAddChildBirthdayCta]: 'Add a Child',
      [lblProfileBirthdaySavingInfo]:
        'Add up to 4 kids’ birthdays to your account and receive special savings during their birthday month!',
      [lblProfileRemoveInfoText]:
        'Are you sure you want to remove $childName$ from the Birthday Savings List?',
      [lblProfileRemoveCTA]: 'YES, REMOVE',
      [lblProfileRemoveCancelCTA]: 'NO',
      [lblProfileRemoveBirthdaySuccess]: 'Your account has been updated.',
      [lblProfileGenericError]:
        'There is an issue in updating your profile information. Please try again.',
      [lblProfileDEFAULTERROR]:
        "We're sorry that we 're unable to complete your birthday savings request at this time.Please try again later.",
      [lblProfileERRDBPOPULATE]: 'There was a problem populating the database',
      [lblProfileERRINVALIDCOOKIE]:
        'Your log in may have been used in another location. For your security, we have logged you out. Please click "Log Out"  at the top of the site and then log in again.',
      [lblProfileASSOCIATEIDNOTVALID]:
        "The Associate ID you entered doesn't match the name in our records. Please try again.",
      [lblProfileTCPEMAILADDRESSALREADYEXIST]:
        'Error: An account with this email address already exists. Please try logging in with your account or using a different email address',
      [lblProfileANERROROCCURREDPLEASETRYAGAIN]: 'AN ERROR OCCURRED PLEASE TRY AGAIN',
      [lblProfilePLEASEENTERAVALIDEXPIRATIONDATE]:
        'PLEASE ENTER A VALID EXPIRATION DATE AND TRY AGAIN',
      [lblProfileTRYLOGGINGOUTANDLOGBACKINORTRYAGAINLATER]:
        'Seems like we ran into a hiccup. Try logging out and then log back in, or try again later. If the problem persists, contact us.',
    },
    preferences: {
      [lblPrefrenceHeading]: 'My Preferences',
      [lblPrefrenceViewPreferences]: 'View Preferences',
      [lblPreferenceTileAdd]: 'Add',
      [lblPreferenceTileContactPreference]: 'Contact Preferences',
      [lblPreferenceTileTextText]: 'TEXTS',
      [lblPreferenceTileAppText]: 'APPS',
      [lblPrefrenceTileFavoriteStore]: 'My Store',
      [lblPreferenceTileAccessBuyOnlinePickup]: 'Find and add a nearby store for easy shopping.',
      [lblPreferenceTileConnectedSocialAccountsHeading]: 'My Social Accounts',
      [lblPreferenceTileConnectedSocialAccountsText]: 'Link your social accounts for extra points!',
    },
  },
  checkout: {
    bagPage: {
      [lblCouponlistAvailable]: 'Available',
      [lblCouponCollapsibleHeader]: 'Rewards & Offers',
      [lblCouponlistApplied]: 'Applied',
      [lblCouponlistRewards]: 'REWARDS',
      [lblConsumeUpTo]:
        'You have consumed ##usedAmount## today, you can apply up to ##remainingAmount## more.',
      [lblRedeem]: 'Redeem',
      [lblConsumed]: 'You have reached your daily redemption limit of ##usedAmount##.',
      [lblPointsRedemptionError]: 'Points can be redeemed after terms and conditions are met.',
      [lblCartAmountError]: 'The redemption amount cannot be greater than the cart total.',
    },
  },
  global: {
    registration: {
      [lblCreateAccountUseTouchId]: 'Enable sign in with Touch ID',
      [lblCreateAccountUseFaceId]: 'Enable sign in with Face ID',
    },
    header: {
      [lblHeaderHelloText]: 'Hello',
    },
    accountDrawer: {
      [lblStartEarningPointsLabel]: 'Start earning points right away!',
      [lblAccoundDashboardNoRewardsOffers]: 'No available rewards or offers.',
      [lblRewardsAndOffersRecentRewards]: 'RECENT REWARDS & OFFERS',
      [lblRewardsAndOffersStartShopping]: 'Shop now to earn points & rewards!',
      [lblAccountDrawerRememberUser]: 'Log in to access them now.',
      [lblAccoundDashboardPaymentGiftCards]: 'PAYMENTS & GIFT CARDS',
      [lblPaymentOverviewTileAddCard]: 'Add a card',
      [lblPaymentOverviewTileAddCreditOrGift]: 'Add a Credit or Gift Card',
      [lblPaymentOverviewTileAddGiftCard]: 'Add a Gift Card',
      [lblPaymentOverviewTileCardNumber]: 'CARD NUMBER',
      [lblPaymentOverviewTileAddCreditCard]: 'Add a Credit Card',
      [lblRewardPointStatusBarViewMyRewards]: 'View My Place Rewards',
      [lblRewardPointStatusBarToNextAward]: 'To next reward',
    },
    cartItemTile: {
      [lblViewAll]: 'View all',
    },
    placeRewards: {
      [lblMyRewardsEmptySupportingText]: 'There are no available offers in your Wallet.',
      [lblMyRewardsEmptySupportingTextUS]:
        'There are no available offers in your Wallet – start shopping to earn points!',
      [lblMyCouponTitle]: 'Offers',
      [lblMyRewardsViewAll]: 'View All ',
      [lblPlaceRewardsBoostYourPoints]: 'Boost Your Points',
      [lblPlaceRewardsBoostYourPointsSubHeading]:
        "More points mean more rewards - don't miss your chance",
      [lblPlaceRewardsAdd]: 'Add',
      [lblPlaceRewardsPointHistoryHeading]: 'Points History',
      [lblPlaceRewardsPointHistorySubHeading]:
        'View your full points history, from earnings to redemptions.',
      [lblPlaceRewardsViewAllWaysToEarn]: 'View All ways to Earn',
    },
    recommendations: {
      [CTA_TEXT]: 'Shop Now',
    },
    myPlaceRewards: {
      [lblShowMemberId]: 'SHOW MEMBER ID',
    },
    addEditAddress: {
      [lblAddEditAddressEmail]: 'Email',
    },
    rewardPoints: {
      [lblRewardPointsCurrentPoints]: 'Current Points',
      [lblRewardPointsHeading]: 'My Rewards',
      [lblRewardPointsNextReward]: 'Points To Next Reward',
    },
    accountTier: {
      [lblAccountTierValidity]: 'Valid till',
      [lblAccountPlccHolder]: 'PLCC Cardholder',
      [lblAccountTierUpgradeTo]: 'Upgrade to',
      [lblAccountTierNextRewardTarget]: 'Spend ##amount## by',
      [lblAccountTierWelMyPlaceHeading]: 'Welcome to My Place Reward',
      [lblAccountTierWelMyPlaceSubHeading]:
        'Check your points, discover new rewards, and make the most of every purchase.',
      [lblAccountTierAvailableReward]: 'Available Reward',
      [lblAccountTierRedeemAt]: 'Redeem at checkout',
      [lblAccountTierYourSpend]: 'You’ve spent:',
      [lblAccountTierUpgradeDescription]: 'to reach ##nextTier## and unlock more benefits.',
      [lblAccountTierMaxTier]: 'Top tier reached!',
      [lblAccountTierMaxTierInfo]: 'Spend ##maxTierSpend## annually to keep it.',
      [lblAccountTierReached]: 'You’ve reached the top tier!',
      [lblAccountTierMaxTierMyPlace]: 'to keep your current tier and benefits.',
    },
    tierBenefits: {
      [lblTierBenefitsHeading]: 'Perks You Haven’t Used Yet',
      [lblTierBenefitsSubHeading]: 'Make the most of your tier—here’s what you can still enjoy',
      [lblTierBenefitsExpiringSoon]: 'Expiring Soon',
      [lblTierBenefitsRemaining]: 'Remaining',
      [lblTierBenefitsUsed]: 'Used',
      [lblLoyaltyBenefitsHeading]: 'Your Tier Benefits',
      [lblLoyaltyBenefitSubHeading]:
        'See what benefits come with your tier—and how much you still have to enjoy.',
      [lblBenefitComparisonHeading]: 'Unlock More at Every Tier',
      [lblBenefitComparisonSubHeading]:
        'Understand your benefits at a glance—and how to unlock more.',
      [lblAllBenefitHeading]: 'All Benefits',
    },
    plccCard: {
      [lblNonPlccUserHeading]: 'Cardholders Enjoy Every Benefit',
      [lblNonPlccUserSubheading]:
        'As a cardmember, you automatically unlock the full set of benefits.',
      [lblPlccUserHeading1]: 'You’re a',
      [lblPlccUserHeading2]: 'Credit Cardholder',
      [lblPlccUserSubheading]: 'Yay! You’ve unlocked all #currentTier# benefits.',
      [lblPlccSavings]: 'Total Savings with PLCC Card:',
    },
  },
};
export default AccountCommonLabels;
